import type { TaskBodyProps } from '../index';
import { advanceWorkflow } from '../../../../services/workQueue';
import { ReviewNotesPanel } from '../final-review/ReviewNotesPanel';
import {
    ReviewDecisionFooter,
    type ReviewDecisionCopy
} from '../final-review/ReviewDecisionFooter';
import { OrthoReviewDxReport } from './OrthoReviewDxReport';
import { ORTHO_REVIEW_STATUS_ID, REDESIGN_ORTHO_REVIEW_STATUS_ID } from '../../constants';

const TAB_DESCRIPTION =
    "Entered on the orthodontist's behalf. The orthodontist approves the design and Dx for the patient or sends feedback to Clinical.";
const HAND_BACK_ACTIONS: Readonly<Record<string, string>> = {
    [ORTHO_REVIEW_STATUS_ID]: 'ortho-request-design-changes',
    [REDESIGN_ORTHO_REVIEW_STATUS_ID]: 'ortho-request-redesign-changes'
};
const COPY: ReviewDecisionCopy = {
    source: 'OrthoReviewTask',
    targetLabel: 'Sends back',
    handBack: 'Send feedback',
    handingBack: 'Sending…',
    handBackError: 'Failed to send the feedback. Please try again.',
    approve: 'Approve for the patient',
    approveError: 'Failed to approve for the patient. Please try again.'
};

// Init-7.1 / Redesign-5.1 (V2): the orthodontist signs off the design and Dx before the GP sees them.
export function OrthoReviewTask({
    workCase: c,
    statusMeta,
    onPayloadChange,
    onTaskComplete
}: TaskBodyProps) {
    return (
        <ReviewNotesPanel
            patientId={c.id}
            macro={statusMeta.macro}
            onPayloadChange={onPayloadChange}
            tabDescription={TAB_DESCRIPTION}
            sectioned={false}
            dxReport={(addNote) => <OrthoReviewDxReport patientId={c.id} addNote={addNote} />}
            footer={(notes) => (
                <ReviewDecisionFooter
                    caseId={c.id}
                    statusMeta={statusMeta}
                    onTaskComplete={onTaskComplete}
                    notes={notes}
                    handBackAction={HAND_BACK_ACTIONS[statusMeta.id]}
                    handBackTarget={null}
                    approve={(action) => advanceWorkflow(c.id, action.action)}
                    approveHint={
                        notes.length > 0 ? 'Remove the notes to approve, or send feedback' : null
                    }
                    copy={COPY}
                />
            )}
        />
    );
}
